/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdAccountOverview } from './AdAccountOverview';
import {
    AdAccountOverviewFromJSON,
    AdAccountOverviewFromJSONTyped,
    AdAccountOverviewToJSON,
    AdAccountOverviewToJSONTyped,
} from './AdAccountOverview';
import type { PartialProfitabilityData } from './PartialProfitabilityData';
import {
    PartialProfitabilityDataFromJSON,
    PartialProfitabilityDataFromJSONTyped,
    PartialProfitabilityDataToJSON,
    PartialProfitabilityDataToJSONTyped,
} from './PartialProfitabilityData';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface ChannelOverview
 */
export interface ChannelOverview {
    /**
     * At least one exact selected source/day has verified media evidence, including observed zero; not completeness.
     * @type {boolean}
     * @memberof ChannelOverview
     */
    hasObservedMediaSpendContribution?: boolean;
    /**
     * 
     * @type {MediaSourceQuality}
     * @memberof ChannelOverview
     */
    mediaSourceQuality?: MediaSourceQuality;
    /**
     * 
     * @type {ChannelOverviewFinanceScopeEnum}
     * @memberof ChannelOverview
     */
    financeScope?: ChannelOverviewFinanceScopeEnum;
    /**
     * 
     * @type {{ [key: string]: MediaSourceQuality; }}
     * @memberof ChannelOverview
     */
    mediaSourceQualityGranular?: { [key: string]: MediaSourceQuality; };
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof ChannelOverview
     */
    partialProfitability?: PartialProfitabilityData | null;
    /**
     * 
     * @type {{ [key: string]: PartialProfitabilityData; }}
     * @memberof ChannelOverview
     */
    partialProfitabilityGranular?: { [key: string]: PartialProfitabilityData; };
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof ChannelOverview
     */
    partialProfitabilityMarketing?: PartialProfitabilityData | null;
    /**
     * 
     * @type {{ [key: string]: PartialProfitabilityData; }}
     * @memberof ChannelOverview
     */
    partialProfitabilityMarketingGranular?: { [key: string]: PartialProfitabilityData; };
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof ChannelOverview
     */
    snapshot?: PrecalculationSnapshotReadMetadata | null;
    /**
     * 
     * @type {Array<AdAccountOverview>}
     * @memberof ChannelOverview
     */
    adAccounts?: Array<AdAccountOverview>;
}


/**
 * @export
 */
export const ChannelOverviewFinanceScopeEnum = {
    CanonicalSelected: 'canonical_selected'
} as const;
export type ChannelOverviewFinanceScopeEnum = typeof ChannelOverviewFinanceScopeEnum[keyof typeof ChannelOverviewFinanceScopeEnum];


/**
 * Check if a given object implements the ChannelOverview interface.
 */
export function instanceOfChannelOverview(value: object): value is ChannelOverview {
    return true;
}

export function ChannelOverviewFromJSON(json: any): ChannelOverview {
    return ChannelOverviewFromJSONTyped(json, false);
}

export function ChannelOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChannelOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'hasObservedMediaSpendContribution': json['hasObservedMediaSpendContribution'] == null ? undefined : json['hasObservedMediaSpendContribution'],
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : MediaSourceQualityFromJSON(json['mediaSourceQuality']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
        'mediaSourceQualityGranular': json['mediaSourceQualityGranular'] == null ? undefined : (mapValues(json['mediaSourceQualityGranular'], MediaSourceQualityFromJSON)),
        'partialProfitability': json['partialProfitability'] === undefined ? undefined : json['partialProfitability'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitability']),
        'partialProfitabilityGranular': json['partialProfitabilityGranular'] == null ? undefined : (mapValues(json['partialProfitabilityGranular'], PartialProfitabilityDataFromJSON)),
        'partialProfitabilityMarketing': json['partialProfitabilityMarketing'] === undefined ? undefined : json['partialProfitabilityMarketing'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitabilityMarketing']),
        'partialProfitabilityMarketingGranular': json['partialProfitabilityMarketingGranular'] == null ? undefined : (mapValues(json['partialProfitabilityMarketingGranular'], PartialProfitabilityDataFromJSON)),
        'snapshot': json['snapshot'] === undefined ? undefined : json['snapshot'] === null ? null : PrecalculationSnapshotReadMetadataFromJSON(json['snapshot']),
        'adAccounts': json['adAccounts'] == null ? undefined : ((json['adAccounts'] as Array<any>).map(AdAccountOverviewFromJSON)),
    };
}

export function ChannelOverviewToJSON(json: any): ChannelOverview {
    return ChannelOverviewToJSONTyped(json, false);
}

export function ChannelOverviewToJSONTyped(value?: ChannelOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasObservedMediaSpendContribution': value['hasObservedMediaSpendContribution'],
        'mediaSourceQuality': MediaSourceQualityToJSON(value['mediaSourceQuality']),
        'financeScope': value['financeScope'],
        'mediaSourceQualityGranular': value['mediaSourceQualityGranular'] == null ? undefined : (mapValues(value['mediaSourceQualityGranular'], MediaSourceQualityToJSON)),
        'partialProfitability': PartialProfitabilityDataToJSON(value['partialProfitability']),
        'partialProfitabilityGranular': value['partialProfitabilityGranular'] == null ? undefined : (mapValues(value['partialProfitabilityGranular'], PartialProfitabilityDataToJSON)),
        'partialProfitabilityMarketing': PartialProfitabilityDataToJSON(value['partialProfitabilityMarketing']),
        'partialProfitabilityMarketingGranular': value['partialProfitabilityMarketingGranular'] == null ? undefined : (mapValues(value['partialProfitabilityMarketingGranular'], PartialProfitabilityDataToJSON)),
        'snapshot': PrecalculationSnapshotReadMetadataToJSON(value['snapshot']),
        'adAccounts': value['adAccounts'] == null ? undefined : ((value['adAccounts'] as Array<any>).map(AdAccountOverviewToJSON)),
    };
}

